import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

function Terms() {
  return (
    <>
      <SEO
        title="Terms of Service"
        description="Terms of Service for Emerging Evidence. Read our terms and conditions for using our consulting services."
        path="/terms"
      />
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.title}>Terms of Service</h1>
          <p style={styles.lastUpdated}>Last updated: January 27, 2026</p>

          <section style={styles.section}>
            <h2 style={styles.heading}>1. Acceptance of Terms</h2>
            <p style={styles.paragraph}>
              By accessing and using the Emerging Evidence website and services, you accept and agree to be bound by the terms and provisions of this agreement.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>2. Use of Services</h2>
            <p style={styles.paragraph}>
              Our consulting services are provided for informational and professional purposes. You agree to use our services in compliance with all applicable laws and regulations.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>3. Intellectual Property</h2>
            <p style={styles.paragraph}>
              All content, trademarks, and intellectual property on this website are owned by Emerging Evidence unless otherwise stated. You may not reproduce, distribute, or create derivative works without prior written consent.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>4. Limitation of Liability</h2>
            <p style={styles.paragraph}>
              Emerging Evidence shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services or website.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>5. Changes to Terms</h2>
            <p style={styles.paragraph}>
              We reserve the right to modify these terms at any time. Continued use of our services following any changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.heading}>6. Contact</h2>
            <p style={styles.paragraph}>
              For questions about these Terms of Service, please <Link to="/contact" style={styles.link}>contact us</Link>.
            </p>
          </section>

          <div style={styles.links}>
            <Link to="/" style={styles.link}>← Back to Home</Link>
            <span style={styles.separator}>|</span>
            <Link to="/privacy" style={styles.link}>Privacy Policy</Link>
          </div>
        </div>
      </div>
    </>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#000",
    color: "#fff",
    padding: "80px 20px 40px",
    boxSizing: "border-box",
  },
  content: {
    maxWidth: "800px",
    margin: "0 auto",
  },
  title: {
    fontSize: "2.5rem",
    marginBottom: "0.5rem",
    fontWeight: "300",
  },
  lastUpdated: {
    fontSize: "0.9rem",
    color: "#888",
    marginBottom: "2rem",
  },
  section: {
    marginBottom: "2rem",
  },
  heading: {
    fontSize: "1.3rem",
    fontWeight: "400",
    marginBottom: "0.75rem",
  },
  paragraph: {
    fontSize: "1rem",
    lineHeight: "1.7",
    color: "#ccc",
  },
  links: {
    marginTop: "3rem",
    paddingTop: "1.5rem",
    borderTop: "1px solid #333",
  },
  link: {
    color: "#fff",
    textDecoration: "underline",
    textUnderlineOffset: "4px",
  },
  separator: {
    margin: "0 1rem",
    color: "#666",
  },
};

export default Terms;
